import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import Login from 'app-support/auth/components/Login'
import Logout from 'app-support/auth/components/Logout'
import { loginRoute, logoutRoute } from 'routes/routeNames'

class AuthRoutes extends React.Component {
  render() {
    return (
      <Switch>
        <Route component={Login} path={loginRoute} />
        <Route component={Logout} path={logoutRoute} />
        <Redirect to='/' />
      </Switch>
    )
  }
}

export default AuthRoutes
